export enum TIPS_TYPE {
  NOT_FOUND = 'not_found',
  DISABLE_TOKEN = 'disable_token',
  FINISHED = 'finished',
  IOS_UNDER_13 = 'ios_under_13',
  BROWER_DISABLE = 'brower_disable',
}
